/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linkidentity_Title1Inputs */

const zh_linkidentity_title1 = /** @type {(inputs: Linkidentity_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绑定新身份`)
};

const en_linkidentity_title1 = /** @type {(inputs: Linkidentity_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link New Identity`)
};

const es_linkidentity_title1 = /** @type {(inputs: Linkidentity_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincular nueva identidad`)
};

/**
* | output |
* | --- |
* | "Link New Identity" |
*
* @param {Linkidentity_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const linkidentity_title1 = /** @type {((inputs?: Linkidentity_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linkidentity_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linkidentity_title1(inputs)
	if (locale === "en") return en_linkidentity_title1(inputs)
	return es_linkidentity_title1(inputs)
});
export { linkidentity_title1 as "linkIdentity_title" }